import axios from "axios";
import { ShipDataType } from "@/types/apiTypes";
import { API_BASE_URL } from "@/utils/api";
import { getToken } from "@/utils/authHelpers";

export const fetchUserShipsApi = async (): Promise<ShipDataType[]> => {
  const token = await getToken();
  if (!token) throw new Error("No authentication token found");

  const response = await axios.get<ShipDataType[]>(
    `${API_BASE_URL}/get-user-ships`,
    { headers: { Authorization: `Bearer ${token}` } },
  );
  return response.data;
};
